import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button,
    MenuItem,
    InputLabel,
    FormControl,
    Grid,
  } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField, Select,Checkbox } from "formik-material-ui";
import { countries, years, Months,industries} from "../listOfCountries"

import * as Yup from "yup";

const infoSchema = Yup.object().shape({
    Title: Yup.string().required('Required'),
    ExpType: Yup.string().required('Required'),
    Country: Yup.string().required('Required'),
    Company: Yup.string().required('Required'),
    startmonth: Yup.string().required('Required'),
    startyear: Yup.string().required('Required'),
    endmonth: Yup.string(),
    endyear: Yup.string(),
    workhere: Yup.boolean(),
    Description: Yup.string().max(800, "Too Long"),
    industry: Yup.string().required('Required'),
    careerLevel: Yup.string().required('Required')
});

const ExperienceModal = (props) => {
    const { user } = useAuth0()
    const [checked, setChecked] = React.useState(null);
    const handleSubmit = async (values, { setSubmitting }) => {
        console.log("here")
        setSubmitting(true);
        if(checked)
        {
           values = {
            Title: values.Title,
            ExpType: values.ExpType,
            Country: values.Country,
            Company: values.Company,
            startmonth: values.startmonth,
            startyear: values.startyear,
            endmonth: "",
            endyear: "",
            workhere: checked==null?values.workhere:checked,
            Description: values.Description,
            industry: values.industry,
            careerLevel: values.careerLevel
           }
        }
        else
        {
            values = {
                Title: values.Title,
                ExpType: values.ExpType,
                Country: values.Country,
                Company: values.Company,
                startmonth: values.startmonth,
                startyear: values.startyear,
                endmonth: values.endmonth,
                endyear: values.endyear,
                workhere: checked==null?values.workhere:checked,
                Description: values.Description,
                industry: values.industry,
                careerLevel: values.careerLevel
               }
        }
        if(props.experience.id === ''){
            fetch(process.env.REACT_APP_IP + `/talent/addexp/${user.sub}`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        } else {
            console.log(values)
            fetch(process.env.REACT_APP_IP + `/talent/editexp/${user.sub}/${props.experience.id}`, {
                method: 'PATCH',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        }
        props.refresh();
        props.onClose();
    }

    return (
            <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title" fullWidth maxWidth={'sm'}>
                <DialogTitle id="form-dialog-title">{ (props.experience.id === '')? "Add" : "Edit"} experience</DialogTitle>
                <Formik
                initialValues={{
                    Title: props.experience.Title,
                    ExpType: props.experience.ExpType,
                    Country: props.experience.Country,
                    Company: props.experience.Company,
                    startmonth: props.experience.startmonth,
                    startyear: props.experience.startyear,
                    endmonth: props.experience.endmonth,
                    endyear: props.experience.endyear,
                    workhere: props.experience.workhere,
                    Description: props.experience.Description,
                    industry: props.experience.industry,
                    careerLevel: props.experience.careerLevel
                }}
                validationSchema={infoSchema}
                onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
                }}
                >
                {({ submitForm, isSubmitting, values }) => (
                    <Form>
                        <DialogContent>
                                <Field fullWidth
                                required
                                component={TextField}
                                name="Title"
                                id="Title"
                                label="Title"
                                rows={1}
                                helperText="Input Title"
                                placeHolder=""
                                />
                            <FormControl fullWidth>
                                <InputLabel htmlFor="experiencetype">Experience Type</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="ExpType"
                                inputProps={{
                                    id: "ExpType",
                                }}>
                                        <MenuItem key={1} value="Full time">Full time</MenuItem>
                                        <MenuItem key={2} value="Part time">Part time</MenuItem>
                                        <MenuItem key={3} value="Internship">Internship</MenuItem>
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="Country">Country</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="Country"
                                inputProps={{
                                    id: "Country",
                                }}>
                                    { countries.map((country, index) => 
                                        <MenuItem key={index} value={country}>{country}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <Field fullWidth
                                required
                                component={TextField}
                                name="Company"
                                id="Company"
                                label="Company"
                                rows={1}
                                helperText="Input Title"
                                placeHolder=""
                                />
                            <Grid container direction='row' justify='space-between' alignItems='center'>
                                <Grid item xs={5}>
                                <FormControl fullWidth>
                                <InputLabel htmlFor="from-month">From</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="startmonth"
                                inputProps={{
                                    id: "startmonth",
                                }}>
                                    { Months.map((month, index) => 
                                        <MenuItem key={index} value={month}>{month}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                            <InputLabel htmlFor="from-year"></InputLabel>
                                <Field
                                required
                                component={Select}
                                name="startyear"
                                inputProps={{
                                    id: "startyear",
                                }}>
                                    { years.map((year, index) => 
                                        <MenuItem key={index} value={year}>{year}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                                </Grid>
                                <Grid item xs={5}>
                                <FormControl fullWidth>
                                <InputLabel htmlFor="to-month">To</InputLabel>
                                <Field
                                required
                                disabled={checked==null?values.workhere:checked}
                                component={Select}
                                name="endmonth"
                                inputProps={{
                                    id: "endmonth",
                                }}>
                                    { Months.map((month, index) => 
                                        <MenuItem key={index} value={month}>{month}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                            <InputLabel htmlFor="to-year"></InputLabel>
                                <Field
                                disabled={checked==null?values.workhere:checked}
                                required
                                component={Select}
                                name="endyear"
                                inputProps={{
                                    id: "endyear",
                                }}>
                                    { years.map((year, index) => 
                                        <MenuItem key={index} value={year}>{year}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                                </Grid>
                            </Grid>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="workhere">I currently work here</InputLabel>
                                <Field
                                required
                                component={Checkbox}
                                name="workhere"
                                inputProps={{
                                    id: "workhere",
                                }}
                                checked={checked==null?values.workhere:checked}
                                onChange={()=>{checked == null? setChecked(values.workhere):setChecked(!checked)
                                }}
                                >
                                </Field>
                            </FormControl>
                            <Field fullWidth
                            name="Description"
                            component={TextField}
                            id="Description"
                            label="Description"
                            multiline
                            rows={3}
                            helperText="max 800 characters"
                            placeHolder=""
                            />
                            <FormControl fullWidth>
                                <InputLabel htmlFor="industry">Industry</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="industry"
                                inputProps={{
                                    id: "industry",
                                }}>
                                    { industries.map((industry, index) => 
                                        <MenuItem key={index} value={industry}>{industry}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="career-level">Career Level</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="careerLevel"
                                inputProps={{
                                    id: "careerLevel",
                                }}>
                                        <MenuItem key={1} value="Junior">Junior</MenuItem>
                                        <MenuItem key={2} value="Senior">Senior</MenuItem>
                                        <MenuItem key={3} value="Other">Other</MenuItem>
                                </Field>
                            </FormControl>
                        </DialogContent>
                        <DialogActions>
                        <Button disabled={isSubmitting} color="primary" onClick={submitForm}>
                            Update
                        </Button>
                        <Button disabled={isSubmitting} color="primary" onClick={props.onClose}>
                            cancel
                        </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
 
export default ExperienceModal;